<script setup lang="ts">
import { mdiCalendar } from '@quasar/extras/mdi-v7';
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // 'update:modelValue': [payload: string]
// }>()
</script>

<template>
  <q-chip
    :dense="!$q.screen.gt.sm"
    :icon="mdiCalendar"
  >
    <slot />
  </q-chip>
</template>
